import { PageSectionsCalloutCardWithImage } from '@/tina/__generated__/types';
import * as stylex from '@stylexjs/stylex';
import Image from 'next/image';
import { tinaField } from 'tinacms/dist/react';
import '../styles/tokens.stylex';
import { borderRadius, color, spacing } from '../styles/tokens.stylex';
import { CalloutCard, CalloutCardDataType } from './CalloutCard';
import { PageSection } from './PageSection';
export interface CalloutWithImageProps {
  data: PageSectionsCalloutCardWithImage;
}
export function CalloutWithImage({
  data
}: CalloutWithImageProps) {
  return <PageSection>
      <div className="xrvj5dj x1y6fwsi x1on1dc6 x1mhrlx8">
        {data?.calloutCard && <CalloutCard data={data.calloutCard as CalloutCardDataType} />}
        <div className="xrhgmaw x712feu x1o5z2k8 xb3r6kr x1n2onr6" data-tina-field={tinaField(data, 'image')}>
          {data?.image && <Image src={data?.image} alt={data?.alt} fill sizes="100%" className="xl1xv1r x8ozjh4" />}
        </div>
      </div>
    </PageSection>;
}